// JSON config defined in Bloomreach
export enum USServicingComponentTypes {
  HELD = 'held',
  FAVORITES = 'favorites',
}

export interface USServicingJSONConfig {
  latestFundDocumentsUrl: string;
  serviceCenterUrl: string;
  myProductsPerformanceUrl: string;
  myProductsPerformance2Url: string;
  showPerformanceLink?: boolean;
  taxInformationUrl: string;
  showTaxInformationLink?: boolean;
  errorServiceCenter: string;
  disableAddPasswordModule: boolean;
  disableLoginForm?: boolean;
  subTitle?: string;
  signInBodyContent?: string;
  signInLegacyContent?: string;
}

export interface USServicingAdditionalJSONConfig {
  title: string;
  type: USServicingComponentTypes;
  titleRiaFirm?: string;
  titleRiaTeam?: string;
}
